<template>
  <div class="refund-page-container">
    <h1>{{ pageContent.title }}</h1>
    <p class="last-updated">{{ pageContent.lastUpdated }}</p>
    <p class="description">{{ pageContent.description }}</p>

    <section
      v-for="section in pageContent.sections"
      :key="section.id"
      :id="section.id"
    >
      <h2>{{ section.title }}</h2>
      <template
        v-for="(paragraph, index) in section.paragraphs || []"
        :key="`${section.id}-paragraph-${index}`"
      >
        <p>{{ paragraph }}</p>
      </template>
      <ul v-if="section.list && section.list.length" class="policy-list">
        <li
          v-for="(item, idx) in section.list"
          :key="`${section.id}-list-${idx}`"
          class="policy-list-item"
        >
          <span class="policy-list-marker">•</span>
          <template v-if="typeof item === 'string'">
            <span class="policy-list-body policy-list-body--plain">
              {{ item }}
            </span>
          </template>
          <template v-else>
            <span class="policy-list-label">
              {{ item.title }}
            </span>
            <span class="policy-list-body">
              {{ item.body }}
            </span>
          </template>
        </li>
      </ul>
      <template
        v-for="(closing, cIdx) in section.closing || []"
        :key="`${section.id}-closing-${cIdx}`"
      >
        <p class="closing">{{ closing }}</p>
      </template>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { refundPolicyContent } from '@/content/refundPolicy';

const { locale } = useI18n();
const pageContent = computed(
  () => refundPolicyContent[locale.value] ?? refundPolicyContent['en-US']
);
</script>

<style scoped>
.refund-page-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 25px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  line-height: 1.7;
  color: #3f3f46;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
}

.refund-page-container h1 {
  text-align: center;
  margin-bottom: 12px;
  color: #1f2937;
  font-size: 2.1rem;
  font-weight: 650;
}

.last-updated {
  text-align: center;
  font-size: 0.94rem;
  color: #6b7280;
  margin-bottom: 20px;
}

.description {
  font-size: 1.05rem;
  color: #374151;
  margin-bottom: 28px;
  text-align: justify;
}

section {
  margin-bottom: 28px;
}

section h2 {
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e5e7eb;
  color: #0f766e;
  font-size: 1.5rem;
  font-weight: 600;
}

section p {
  margin-bottom: 12px;
  color: #3f3f46;
  text-align: justify;
}

.policy-list {
  margin: 0 0 16px 0;
  padding: 0;
  list-style: none;
  color: #3f3f46;
  text-align: left;
}

.policy-list-item {
  position: relative;
  padding-left: 1.6rem;
  margin-bottom: 12px;
  line-height: 1.6;
  text-align: left;
}

.policy-list-marker {
  position: absolute;
  left: 0;
  top: 0.35rem;
  font-size: 1.05rem;
  color: #0f766e;
}

.policy-list-label {
  display: inline-block;
  min-width: 7em;
  color: #b45309;
  font-weight: 600;
}

.policy-list-body {
  display: inline;
  text-align: left;
}

.policy-list-body--plain {
  display: block;
  text-align: left;
}
.closing {
  font-style: italic;
  color: #4b5563;
}
</style>
